var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shows"},[_c('h1',[_vm._v("Shows")]),_vm._v(" "),_c('div',{staticClass:"data"},_vm._l((_vm.shows),function(show){return _c('div',{key:show.name,staticClass:"panel show",on:{"click":function($event){return _vm.open(show)}}},[_vm._v("\n      "+_vm._s(show.name)+"\n    ")])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a2ded5e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shows.vue
// module id = null
// module chunks = 